export default __webpack_public_path__ + "static/media/153.84a647d7.png";